import React, { useState, useEffect, useContext } from "react";
import Select from "react-select";
import ReactSelect from "react-select";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { validationSchema } from "../../models/ValidationSchema";
import "../../styles/pages/home/FormPage.scss";
import { Trans, useTranslation } from "react-i18next";
import { countries } from "../../data/Data";
import {
  fetchCourse,
  submitForm,
  checkDuplcateSubmission,
} from "../../api/apiManagement";
import { GlobalContext } from "../../App";
import { HomeContext } from "./Home";
import Popup from "../../components/Popup";

function Form() {
  const {
    canFetchData,
    setCanFetchData,
    setIsLoading,
    isLoading,
    isLogin,
    submitData,
    setSubmitData,
    infoData,
  } = useContext(GlobalContext);

  const {
    setIsPreview,
    submitErrorMessage,
    setSubmitErrorMessage,
    setIsWaitingList,
    haveWorkshopCode,
    setHaveWorkshopCode,
  } = useContext(HomeContext);

  const { t, i18n } = useTranslation();

  const queryParameters = new URLSearchParams(window.location.search);
  let code = "";
  if (queryParameters.get("code")) {
    code = queryParameters.get("code");
  }
  let workshop_code = "";
  if (queryParameters.get("workshop_code")) {
    workshop_code = queryParameters.get("workshop_code");
  }

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    setValue,
    watch,
    getValues,
  } = useForm({
    defaultValues: {
      select: { value: "852", label: "+852" },
    },
    resolver: yupResolver(validationSchema),
  });

  const [openPopup, setOpenPopup] = useState(false);
  const [popupRegistered, setPopupRegistered] = useState(false);
  const [end, setEnd] = useState(false);
  const [popupData, setPopUpdata] = useState([]);
  const [formData, setFormData] = useState([]);

  // State to track the last clicked dropdown
  const [isDisabledName, setIsDisabledName] = useState(true);
  const [isDisabledLocation, setIsDisabledLocation] = useState(true);
  const [isDisabledDate, setIsDisabledDate] = useState(true);
  const [isDisabledTime, setIsDisabledTime] = useState(true);

  const [locationList, setLocationList] = useState([]);
  const [dateList, setDateList] = useState([]);
  const [timeList, setTimeList] = useState([]);

  // Api loading
  const [userData, setUserData] = useState({});

  useEffect(() => {
    if (isLogin) {
      setUserData(JSON.parse(localStorage.getItem("user_data")));
    }
  }, [isLogin]);

  //get Course
  useEffect(() => {
    let data;
    data = { lang: i18n.language, code: code, workshop_code: workshop_code };

    if (isLogin) {
      data.sua_id = JSON.parse(localStorage.getItem("user_data"))?.sua_id;
      data.token = JSON.parse(localStorage.getItem("jwt"))?.signature;
    }

    if (canFetchData) {
      fetchCourse(data)
        .then((res) => {
          if (res.data.StatusCode === 701) {
            setOpenPopup(true);
            setEnd(true);
          }
          if (workshop_code === "") {
            handleClearDropdownData(0);
            setHaveWorkshopCode(false);
            setFormData(res.data.Data);
            setValue("eventName", res.data.Data[0]);
          } else {
            handleClearDropdownData(99);
            setHaveWorkshopCode(true);
            setSubmitData({
              event_name: res.data.Data[0]?.title,
              event_address: res.data.Data[0]?.workshop_location[0]?.address,
              workshop_date:
                res.data.Data[0]?.workshop_location[0]?.workshop_date[0]?.date,
              event_time_slot:
                res.data.Data[0]?.workshop_location[0]?.workshop_date[0]
                  ?.workshop_time[0]?.time_slot,
              workshop_detail_id:
                res.data.Data[0]?.workshop_location[0]?.workshop_date[0]
                  ?.workshop_time[0]?.workshop_detail_id,
            });
            setValue("eventName", {});
            setValue("eventLocation", {});
            setValue("eventDate", {});
            setValue("eventTime", {});
          }
        })
        .catch((err) => console.log(err));
      setCanFetchData(false);
    }
  }, [canFetchData, isLogin]);

  useEffect(() => {
    console.log(errors);
    console.log(getValues());
  }, [watch("first_name")]);

  //eventName
  useEffect(() => {
    if (formData && formData.length > 0 && workshop_code == "") {
      setDateList(
        formData.filter((x) => x?.title === watch("eventName")?.title)
      );
    }
    console.log(watch("eventName"));
  }, [watch("eventName")]);

  //eventLocation
  useEffect(() => {
    if (dateList && dateList.length > 0 && workshop_code == "") {
      setLocationList(
        dateList[0]?.workshop_location.filter(
          (x) => x?.address === watch("eventLocation")?.address
        )
      );
    }
    console.log(watch("eventLocation"));
  }, [watch("eventLocation")]);

  //  eventDate
  useEffect(() => {
    if (locationList && locationList.length > 0 && workshop_code == "") {
      setTimeList(
        locationList[0]?.workshop_date.filter(
          (x) => x?.date === watch("eventDate")?.date
        )
      );
    }
  }, [watch("eventDate")]);

  function handleClearDropdownData(n) {
    if (n === 0) {
      setValue("eventDate", { value: "", label: "" });
      setValue("eventLocation", { value: "", label: "" });
      setValue("eventTime", { value: "", label: "" });
      setIsDisabledName(false);
      setIsDisabledLocation(false);
      setIsDisabledDate(true);
      setIsDisabledTime(true);
    } else if (n === 1) {
      setValue("eventDate", { value: "", label: "" });
      setValue("eventTime", { value: "", label: "" });
      setIsDisabledDate(false);
      setIsDisabledTime(true);
    } else if (n === 2) {
      setValue("eventTime", { value: "", label: "" });
      setIsDisabledTime(false);
    } else if (n === 99) {
      setIsDisabledLocation(true);
      setIsDisabledDate(true);
      setIsDisabledTime(true);
      setIsDisabledName(true);
    }
  }

  function onSubmitData(d) {
    console.log(d);
    var newsLetter;
    if (d.promotion) {
      newsLetter = 1;
    } else {
      newsLetter = 0;
    }

    if (isLogin) {
      d.first_name = userData.first_name;
      d.last_name = userData.last_name;
      d.phone = userData.mobile;
      d.email = userData.email;
      d.sua_id = userData.sua_id;
      d.token = JSON.parse(localStorage.getItem("jwt"))?.signature;
    }

    let data;
    if (haveWorkshopCode) {
      data = {
        workshop_detail_id: submitData?.workshop_detail_id,
        workshop_date: submitData?.workshop_date,
        first_name: d.first_name,
        last_name: d.last_name,
        email: d.email,
        phone: d.select.value + d.mobile,
        lang: i18n.language,
        newsletter: newsLetter,
        sua_id: d.sua_id,
        token: d.token,
        action: "walk_in",
      };
    } else {
      data = {
        workshop_detail_id: d.eventTime.workshop_detail_id,
        workshop_date: d.eventDate.date,
        first_name: d.first_name,
        last_name: d.last_name,
        email: d.email,
        phone: d.select.value + d.mobile,
        lang: i18n.language,
        newsletter: newsLetter,
        sua_id: d.sua_id,
        token: d.token,
        action: "preview",
      };
    }

    console.log(data);

    setIsLoading(true);

    submitForm(data)
      .then((res) => {
        const currentStatusCode = res.data.StatusCode;
        if (!haveWorkshopCode) setSubmitData(data);

        if (currentStatusCode === 200) {
          setSubmitErrorMessage("");
          setIsWaitingList(false);
          if (haveWorkshopCode) {
            setSubmitData((preStatus) => ({
              ...preStatus,
              event_name: submitData?.event_name,
              event_address: submitData?.event_address,
              event_time_slot: submitData?.event_time_slot,
              action: "walk_in",
            }));
          } else {
            setSubmitData((preStatus) => ({
              ...preStatus,
              event_name: getValues("eventName")?.title,
              event_address: getValues("eventLocation")?.address,
              event_time_slot: getValues("eventTime")?.time_slot,
              action: "submit",
            }));
          }
          setIsPreview(true);
        } else if (currentStatusCode === 201) {
          setIsWaitingList(true);

          setSubmitErrorMessage("");
          setSubmitData((preStatus) => ({
            ...preStatus,
            event_name: getValues("eventName")?.title,
            event_address: getValues("eventLocation")?.address,
            event_time_slot: getValues("eventTime")?.time_slot,
            action: "submit",
          }));
          setIsPreview(true);
        } else if (currentStatusCode === 501) {
          setSubmitErrorMessage(t("global:statusCode_501"));
        } else if (currentStatusCode === 502) {
          setSubmitErrorMessage(t("global:statusCode_502"));
        } else if (currentStatusCode === 503) {
          setSubmitErrorMessage(t("global:statusCode_503"));
        }
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  }

  function checkDuplcateData(d) {
    console.log(d);
    var newsLetter;
    if (d.promotion) {
      newsLetter = 1;
    } else {
      newsLetter = 0;
    }
    let data;
    if (haveWorkshopCode) {
      data = {
        workshop_detail_id: submitData?.workshop_detail_id,
        email: d.email,
        phone: d.select.value + d.mobile,
        lang: i18n.language,
      };
    }
    setSubmitData((prevState) => ({
      ...prevState,
      first_name: d.first_name,
      last_name: d.last_name,
      email: d.email,
      phone: d.select.value + d.mobile,
      lang: i18n.language,
      newsletter: newsLetter,
      action: "walk_in",
    }));
    setIsLoading(true);
    checkDuplcateSubmission(data)
      .then((res) => {
        const currentStatusCode = res.data.StatusCode;
        if (currentStatusCode === 200) {
          setSubmitErrorMessage("");
          setIsWaitingList(false);
          setIsPreview(true);
        } else if (currentStatusCode === 201) {
          setOpenPopup(true);
          setPopupRegistered(true);
          setPopUpdata([
            t("formPage:eventName") + " : " + res.data.Data.title,
            t("formPage:eventLocation") + " : " + res.data.Data.location,
            t("formPage:eventTime") + " : " + res.data.Data.timeslot,
            t("formPage:eventDate") +
              " : " +
              res.data.Data.workshop_date.split("T")[0],
          ]);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  }

  return (
    <div className="form-page-container">
      <div className="form-d">
        {Object.keys(infoData).length === 0 ? (
          <></>
        ) : i18n.language === "hk" ? (
          <span dangerouslySetInnerHTML={{ __html: infoData.html_tc }}></span>
        ) : (
          <span dangerouslySetInnerHTML={{ __html: infoData.html_eng }}></span>
        )}
      </div>
      <div className="form-d-2">
        <Trans i18nKey="formPage:form_d_2" />
      </div>
      <div className="fields-marked">
        <Trans i18nKey="formPage:fields_marked_a" /> (
        <span className="red-start">*</span>){" "}
        <Trans i18nKey="formPage:fields_marked_b" />
      </div>
      <form className="form-container">
        {popupData.event_name}
        {openPopup && popupRegistered ? (
          <Popup
            title={t("formPage:popupTitle")}
            buttonLeftText={"是"}
            buttonRightText={"否"}
            detail={popupData}
            handleClick={handleSubmit(onSubmitData)}
            setOpenPopup={setOpenPopup}
          />
        ) : (
          <></>
        )}

        {openPopup && end && workshop_code == "" ? (
          <Popup
            title={t("formPage:popupEnd")}
            haveButton={false}
            haveCloseButton={false}
          />
        ) : (
          <></>
        )}
        {/**Last Name 姓氏  First Name 名字*/}
        <div className="input-row">
          <div className="input-container">
            <div className="input-label-container">
              <div className="input-label">
                <span className="red-start">*</span>{" "}
                <Trans i18nKey="formPage:lastName" />
              </div>
            </div>
            {isLogin ? (
              <div className="input-box">{userData.last_name}</div>
            ) : (
              <>
                <input
                  className="input-box"
                  type="text"
                  {...register("last_name", { required: true })}
                />
                {errors.last_name && (
                  <span className="input-error-message">
                    {errors.last_name?.message === "fieldRequired" ? (
                      <Trans i18nKey="validation:lastName_error" />
                    ) : (
                      <></>
                    )}
                  </span>
                )}
              </>
            )}
          </div>
          <div className="input-container">
            <div className="input-label-container">
              <div className="input-label">
                <span className="red-start">*</span>
                <Trans i18nKey="formPage:firstName" />
              </div>
            </div>
            {isLogin ? (
              <div className="input-box">{userData.first_name}</div>
            ) : (
              <>
                <input
                  className="input-box"
                  type="text"
                  {...register("first_name", { required: true })}
                />
                {errors.first_name && (
                  <span className="input-error-message">
                    {errors.last_name?.message === "fieldRequired" ? (
                      <Trans i18nKey="validation:firstName_error" />
                    ) : (
                      <></>
                    )}
                  </span>
                )}
              </>
            )}
          </div>
        </div>
        {/**Last Name 姓氏  First Name 名字*/}
        {/* 手提號碼*/}
        <div className="input-row">
          <div className="input-container" style={{ width: "100%" }}>
            <div className="input-label-container">
              <div className="input-label">
                <span className="red-start">*</span>{" "}
                <Trans i18nKey="formPage:mobileNumber" />
              </div>
            </div>
            <div className="mobile-input-box-container">
              <Controller
                control={control}
                className="mobile-dropdown-list"
                name="select.value"
                render={({ value, ref, field }) => (
                  <Select
                    {...field}
                    inputRef={ref}
                    classNamePrefix="dropdown-class-countries"
                    options={countries}
                    defaultValue={{ label: "+852", value: "852" }}
                    value={countries.find((c) => c.value === value)}
                    onChange={(val) => field.onChange(val.value)}
                    isSearchable={false}
                  />
                )}
              />
              <input
                className="input-box"
                type="tel"
                maxLength={11}
                {...register("mobile", { required: true })}
              />
            </div>
            {errors.mobile && (
              <span className="input-error-message">
                {errors.mobile.message === "fieldRequired" ? (
                  <Trans i18nKey="validation:mobileNumber_error" />
                ) : (
                  <></>
                )}
              </span>
            )}
          </div>
        </div>
        {/* 手提號碼*/}
        {/**電郵地址*/}
        <div className="input-row">
          <div className="input-container" style={{ width: "100%" }}>
            <div className="input-label-container">
              <div className="input-label">
                <span className="red-start">*</span>{" "}
                <Trans i18nKey="formPage:emailAddress" />
              </div>
            </div>
            {isLogin ? (
              <div className="input-box">{userData.email}</div>
            ) : (
              <>
                <input
                  className="input-box"
                  type="email"
                  {...register("email", {
                    required: true,
                    pattern: /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/,
                  })}
                />
                {errors.email && (
                  <span className="input-error-message">
                    {errors.email.message === "fieldRequired" ? (
                      <Trans i18nKey="validation:emailAddress_error" />
                    ) : (
                      <></>
                    )}
                  </span>
                )}
              </>
            )}
          </div>
        </div>
        {/**電郵地址*/}
        {/**Event Name*/}
        <div className="input-row">
          <div className="input-container" style={{ width: "100%" }}>
            <div className="input-label-container">
              <div className="input-label">
                <span className="red-start">*</span>{" "}
                <Trans i18nKey="formPage:eventName" />
              </div>
            </div>
            {haveWorkshopCode ? (
              <div className="input-box">{submitData?.event_name}</div>
            ) : (
              <Controller
                name="eventName"
                control={control}
                rules={{ required: true }}
                render={({ field }) => {
                  return (
                    <ReactSelect
                      {...field}
                      name="eventName"
                      classNamePrefix="filter"
                      options={formData}
                      getOptionLabel={(option) => option.title}
                      getOptionValue={(option) => option.title}
                      placeholder=""
                      onChange={(x) => {
                        field.onChange(x);
                        handleClearDropdownData(0);
                      }}
                      isDisabled={isDisabledName}
                    />
                  );
                }}
              />
            )}
            {errors.eventName && (
              <span className="input-error-message">
                {errors.eventName === "fieldRequired" ? (
                  <Trans i18nKey="validation:eventName_error" />
                ) : (
                  <></>
                )}
              </span>
            )}
          </div>
        </div>
        {/**Event Name*/}
        {/**Event Location*/}
        <div className="input-row">
          <div className="input-container" style={{ width: "100%" }}>
            <div className="input-label-container">
              <div className="input-label">
                <span className="red-start">*</span>{" "}
                <Trans i18nKey="formPage:eventLocation" />
              </div>
            </div>
            {haveWorkshopCode ? (
              <div className="input-box">{submitData?.event_address}</div>
            ) : (
              <Controller
                name="eventLocation"
                control={control}
                rules={{ required: true }}
                render={({ field }) => {
                  return (
                    <>
                      <ReactSelect
                        {...field}
                        classNamePrefix="filter"
                        options={dateList[0]?.workshop_location}
                        getOptionLabel={(option) => option?.address}
                        getOptionValue={(option) => option?.address}
                        placeholder=""
                        onChange={(x) => {
                          field.onChange(x);
                          handleClearDropdownData(1);
                        }}
                        isDisabled={isDisabledLocation}
                      />
                    </>
                  );
                }}
              />
            )}
            {errors.eventLocation && (
              <span className="input-error-message">
                {errors.eventLocation.message === "fieldRequired" ? (
                  <Trans i18nKey="validation:eventLocation_error" />
                ) : (
                  <></>
                )}
              </span>
            )}
          </div>
        </div>
        {/**Event Location*/}
        {/**Event Date*/}
        <div className="input-row">
          <div className="input-container" style={{ width: "100%" }}>
            <div className="input-label-container">
              <div className="input-label">
                <span className="red-start">*</span>{" "}
                <Trans i18nKey="formPage:eventDate" />
              </div>
            </div>
            {haveWorkshopCode ? (
              <div className="input-box">{submitData?.workshop_date}</div>
            ) : (
              <Controller
                name="eventDate"
                control={control}
                rules={{ required: true }}
                render={({ field }) => {
                  return (
                    <ReactSelect
                      {...field}
                      classNamePrefix="filter"
                      options={locationList[0]?.workshop_date}
                      getOptionLabel={(option) => option?.date}
                      getOptionValue={(option) => option?.date}
                      placeholder=""
                      onChange={(x) => {
                        field.onChange(x);
                        handleClearDropdownData(2);
                      }}
                      isDisabled={isDisabledDate}
                    />
                  );
                }}
              />
            )}
            {errors.eventDate && (
              <span className="input-error-message">
                {errors.eventDate.message === "fieldRequired" ? (
                  <Trans i18nKey="validation:eventDate_error" />
                ) : (
                  <></>
                )}
              </span>
            )}
          </div>
        </div>
        {/**Event Date*/}

        {/**Event Time*/}
        <div className="input-row">
          <div className="input-container" style={{ width: "100%" }}>
            <div className="input-label-container">
              <div className="input-label">
                <span className="red-start">*</span>{" "}
                <Trans i18nKey="formPage:eventTime" />
              </div>
            </div>
            {haveWorkshopCode ? (
              <div className="input-box">{submitData?.event_time_slot}</div>
            ) : (
              <Controller
                name="eventTime"
                control={control}
                rules={{ required: true }}
                render={({ field }) => {
                  return (
                    <ReactSelect
                      {...field}
                      classNamePrefix="filter"
                      options={timeList[0]?.workshop_time}
                      getOptionLabel={(option) => option?.time_slot}
                      getOptionValue={(option) => option?.time_slot}
                      placeholder=""
                      onChange={(x) => {
                        field.onChange(x);
                        handleClearDropdownData(3);
                      }}
                      isDisabled={isDisabledTime}
                      isOptionDisabled={(option) => option.quota === 0}
                    />
                  );
                }}
              />
            )}

            {errors.eventTime && (
              <span className="input-error-message">
                {errors.eventTime.message === "fieldRequired" ? (
                  <Trans i18nKey="validation:eventTime_error" />
                ) : (
                  <></>
                )}
              </span>
            )}
          </div>
        </div>
        {/**Event Time*/}
        {/**TNC*/}
        <div className="input-row">
          <div
            className="input-container"
            style={{ width: "100%", height: "100%" }}
          >
            <div className="checkbox-container">
              <div className="input-checkbox-container">
                <input
                  className="input-checkbox"
                  type="checkbox"
                  {...register("tnc", {
                    required: true,
                  })}
                />
              </div>
              <div className="input-label-container">
                <div className="input-label">
                  <div className="checkbox-text-container">
                    <span className="red-start">*</span>{" "}
                    <div
                      className="checkbox-text"
                      dangerouslySetInnerHTML={{ __html: t("formPage:tnc") }}
                    />
                  </div>
                </div>
              </div>
            </div>

            {errors.tnc && (
              <span className="input-error-message">
                {errors.tnc.message === "fieldRequired" ? (
                  <Trans i18nKey="validation:tnc_error" />
                ) : (
                  <></>
                )}
              </span>
            )}
          </div>
        </div>
        {/**TNC*/}
        {/**推廣訊息*/}
        <div className="input-row">
          <div
            className="input-container"
            style={{ width: "100%", height: "100%" }}
          >
            <div className="checkbox-container">
              <div className="input-checkbox-container">
                <input
                  className="input-checkbox"
                  type="checkbox"
                  {...register("promotion", {
                    required: false,
                  })}
                />
              </div>
              <div className="input-label-container">
                <div className="input-label">
                  <div className="checkbox-text-container">
                    <span
                      className="checkbox-text"
                      dangerouslySetInnerHTML={{
                        __html: t("formPage:promotion"),
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
            {errors.promotion && (
              <span className="input-error-message">
                * <Trans i18nKey="formPage:promotion_error" />
              </span>
            )}
          </div>
        </div>
        {/**推廣訊息*/}
        <div className="submit-container">
          <span
            className="submit-error-message"
            dangerouslySetInnerHTML={{ __html: submitErrorMessage }}
          ></span>
          {haveWorkshopCode ? (
            <button
              type="button"
              className="submit-button"
              onClick={handleSubmit(checkDuplcateData)}
            >
              <Trans i18nKey="formPage:submitButton" />
            </button>
          ) : (
            <button
              onClick={handleSubmit(onSubmitData)}
              value="submit"
              className="submit-button"
            >
              <Trans i18nKey="formPage:submitButton" />
            </button>
          )}
        </div>
      </form>
    </div>
  );
}

export default Form;
/*

*/
